import comp from "./BenchmarksModal";
export default comp;
